export default {
  "titre": "title",
  "description": "description",
  "statut": "status",
  "projet": "project",
  "responsable": "assignee",
  "et collez-les ci-dessous.": "and paste them below.",
  "Administration": "Admin",
  " / mois": " / month",
  "Trop de tentatives. Patientez une minute.": "Too many attempts. Wait a minute.",
  "(vous)": "(you)",
  "1 création offerte ce mois-ci": "1 free creation this month",
  "{0} créations offertes ce mois-ci": "{0} free creations this month",
  "jours": "days",
  "Effet estimé sur le solde central à {0} jours :": "Estimated effect on the base-case balance at {0} days:",
  "mensuel": "monthly",
  "trimestriel": "quarterly",
  "annuel": "yearly",
  "« {0} » ({1} / {2})": "“{0}” ({1} / {2})",
  "dimanche": "Sunday",
  "lundi": "Monday",
  "mardi": "Tuesday",
  "mercredi": "Wednesday",
  "jeudi": "Thursday",
  "vendredi": "Friday",
  "samedi": "Saturday",
  "contient": "contains",
  "{0} à {1} h": "{0} at {1}:00",
  " et ": " and ",
  "{0}/{1} tâches terminées": "{0}/{1} tasks done",
  " ({0} % dans les délais)": " ({0}% on time)",
  "se termine": "ends",
  "fin de l'essai": "trial ends",
  "renouvellement": "renews",
  "Note libre, procédure ou ressource de référence.": "Free-form note, procedure or reference resource.",
  "Coach IA non configuré": "AI Coach not configured",
  "0 €": "€0",
  "Aussi sur votre téléphone": "Also on your phone",
  "Copilote de relance client": "Client Follow-up Copilot",
  "Limites appliquées automatiquement selon la formule de chaque compte.": "Limits applied automatically according to each account's plan.",
  "1er novembre 2026": "November 1, 2026",
  "Seulement si vous l'acceptez : conseils et présentation de nos formules par e-mail, au plus une fois par semaine (consentement, retirable en un clic dans chaque e-mail ou dans Paramètres › Notifications).": "Only if you agree: tips and presentation of our plans by email, at most once a week (consent, withdrawable in one click in every email or in Settings › Notifications).",
  "Conseils et offres par e-mail": "Tips and offers by email",
  "Astuces pour votre activité et présentation des formules quand vous atteignez une limite (au plus un e-mail par semaine).": "Tips for your business and a presentation of our plans when you reach a limit (at most one email a week).",
  "Recevoir les conseils et offres par e-mail": "Receive tips and offers by email",
  "Astuces pour votre activité et nouveautés de GBC Coach IA. Au plus un e-mail par semaine, désabonnement en un clic. Facultatif.": "Tips for your business and GBC Coach IA news. At most one email a week, one-click unsubscribe. Optional.",
  "Se désabonner": "Unsubscribe",
  "{0} jours d'essai gratuit, sans engagement, résiliable à tout moment.": "{0}-day free trial, no commitment, cancel anytime.",
  "Débloquez « {0} » avec {1}": "Unlock “{0}” with {1}",
  "Votre Copilote a atteint sa limite du jour": "Your Copilot has reached today's limit",
  "Bonjour {0}, vous avez voulu utiliser « {1} ». Cette fonction est incluse dans la formule {2} :": "Hello {0}, you tried to use “{1}”. This feature is included in the {2} plan:",
  "Bonjour {0}, vous avez utilisé vos {1} requêtes IA d'aujourd'hui. Avec la formule {2}, votre Copilote vous accompagne bien plus :": "Hello {0}, you've used your {1} AI requests for today. With the {2} plan, your Copilot does much more for you:",
  "Vous recevez cet e-mail car vous avez accepté de recevoir les conseils et offres de GBC Coach IA.": "You're receiving this email because you agreed to receive tips and offers from GBC Coach IA.",
  "C'est noté.": "Done.",
  "Vous ne recevrez plus nos conseils et offres par e-mail. Vous pouvez les réactiver à tout moment dans Paramètres › Notifications.": "You will no longer receive our tips and offers by email. You can turn them back on at any time in Settings › Notifications.",
  "Lien invalide": "Invalid link",
  "Ce lien de désabonnement n'est pas valide. Désactivez les offres dans Paramètres › Notifications.": "This unsubscribe link isn't valid. Turn off offers in Settings › Notifications.",
  "Installez l'appli gratuite": "Get the free app",
  "Application mobile": "Mobile app",
  "Installer": "Get",
  "Télécharger dans l'App Store": "Download on the App Store",
  "Télécharger dans": "Download on the",
  "l'App Store": "App Store",
  "Disponible sur Google Play": "Get it on Google Play",
  "Disponible sur": "Get it on",
} as Record<string, string>;
